import { clone as _clone } from "lodash";

export default {

    adjustCropCoordinates(cropCoordinates, aspectRatio, width, height) {
        let coords = cropCoordinates && cropCoordinates.length === 4 ? _clone(cropCoordinates) : [0, 0, 0, 0];
        // Automatically set crop coordinates to nice values if no crop yet
        // aspectRatio = width / height
        if(coords[0] === 0 && coords[1] === 0 && coords[2] === 0 && coords[3] === 0) {
            coords[2] = Math.floor(Math.min(width, height * aspectRatio));
            coords[3] = Math.floor(Math.min(height, width / aspectRatio));
        }

        return coords;
    }

};



// WEBPACK FOOTER //
// ./js/mywort/commons/components/picture-upload-crop/PictureCropUtils.js